import { render, staticRenderFns } from "./Practice.vue?vue&type=template&id=04d3bcc8&scoped=true"
import script from "./Practice.vue?vue&type=script&lang=js"
export * from "./Practice.vue?vue&type=script&lang=js"
import style0 from "./Practice.vue?vue&type=style&index=0&id=04d3bcc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d3bcc8",
  null
  
)

export default component.exports